import { useState } from 'react'
import { customerData, CustomerInvoiceData } from '../../utilities/CustomerData'
import { apiURL } from '../../utilities/URLs'
import DashboardTOSModal from '../Dashboard/DashboardScreens/DashboardTOS/DashboardTOS'
import { useNavigate } from 'react-router-dom'
import { GenerateInvoicePostPaid, GenerateInvoicePrePaid } from './PaymentModals'
import { refreshAccessToken } from '../../utilities/extensions'
import posthog from 'posthog-js'

export function RefundCalculatedWindow() {
  const navigate = useNavigate()

  const [showTOS, setShowTOS] = useState(false)
  const [customerStageTreeIndex, setCustomerStageTreeIndex] = useState(customerData.customerStageHistory.find(stage => stage.currentStage === true).customerStageTreeIndex)
  const [generatingInvoice, setGeneratingInvoice] = useState(false)
  const [showPostPaidInvoice, setShowPostPaidInvoice] = useState(false)
  const [showPrePaidInvoice, setShowPrePaidInvoice] = useState(false)
  const [tosCustomerFee, setTOSCustomerFee] = useState(0.15)
  const [tosOptionClicked, setTOSOptionClicked] = useState(0)

  const handledSignedAndSetFee = async () => {
    await handleSignedTOS(tosCustomerFee, tosOptionClicked)
  }

  const handleShowInvoiceModal = () => {
    navigate('/refundCalculated')
  }

  const handleSignedTOS = async (customerFee, optionClicked) => {
    setShowTOS(false)
    setGeneratingInvoice(true)

    const formData = new FormData()
    formData.append('customerInvoiceInfo', JSON.stringify({
      zohoId: customerData.customerLeadData.leadId,
      customerId: customerData.customerLeadData.leadContact.contactId,
      invoiceId: customerData.customerInvoiceData.invoiceId,
      customerName: customerData.customerLeadData.leadContact.contactName,
      customerEmail: customerData.customerLeadData.leadContact.contactEmail,
      customerRefundAmount: customerData.customerLeadData.leadAmount,
      customerFee: customerFee,
      invoicePaymentType: optionClicked === 1 ? 'Post-Paid' : 'Pre-Paid',
      currentInvoiceLink: customerData.customerInvoiceData.invoiceLinkURL
    }))

    const generateInvoiceResponse = await fetch(`${apiURL}/api/generateInvoice`, {
      method: 'POST',
      body: formData,
      headers: {
        'Authorization': customerData.accessToken
      }
    })
    const generateInvoiceData = await generateInvoiceResponse.json()
    setGeneratingInvoice(false)

    if (generateInvoiceData.response.error) {
      if (generateInvoiceData.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleSignedTOS(customerFee, optionClicked) : navigate('/', { state: { expired: true } })
      } else
        console.error(generateInvoiceData.response.error)
    } else {
      posthog.stopSessionRecording()
      customerData.customerInvoiceData = new CustomerInvoiceData(generateInvoiceData.response.invoiceData.invoiceInfo)

      if (customerData.customerLeadData.leadId === '6023320000030939004')
        navigate('/shippoRates', { state: { isPostPaid: optionClicked === 1 ? true : false } })
      else
        navigate(optionClicked === 1 ? '/addPaymentMethod' : '/paymentPortal')
    }
  }

  return (
    <>
      <div className='shadow-full rounded-xl p-4 lg:w-full w-11/12 h-fit flex flex-col bg-[#bceda6] font-robo'>
        <div className='w-full max-sm:scale-90'>
          <p className='font-bold text-3xl text-center mt-4'>Your Refund Is Calculated!</p>
          <div className='flex flex-row justify-center items-center mb-10 mt-10'>
            <div className='flex flex-col justify-center items-center w-1/2'>
              <p className='mb-4'>Calculated Refund</p>
              <p className='font-bold text-5xl mb-10'>${customerData.customerLeadData.leadAmount.toLocaleString()}</p>
              {customerData.customerDocuments.irsBalance > 500 && (
                <>
                  <p className='mb-4'>IRS Balance</p>
                  <p className='font-bold text-4xl text-[#c31845]'>${customerData.customerDocuments.irsBalance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                </>
              )}
            </div>
            <div className='w-px h-40 bg-gray-400 mx-4'></div>
            <div className='flex flex-col justify-center items-center w-1/2'>
              <p className='mb-10'>Congratulations! Your Self-Employment Tax Credit Refund has now been calculated!</p>
              <button onClick={handleShowInvoiceModal} className='bg-blue-500 hover:bg-blue-600 transition duration-200 w-40 h-12 rounded-lg text-white'>Get My Refund</button>
            </div>
          </div>
        </div>
      </div>
      <GenerateInvoicePostPaid
        isOpen={showPostPaidInvoice}
        setIsOpen={setShowPostPaidInvoice}
        setShowTOS={setShowTOS}
        handleSignedTOS={handleSignedTOS}
        setTOSCustomerFee={setTOSCustomerFee}
        setTOSOptionClicked={setTOSOptionClicked}
        generatingInvoice={generatingInvoice}
      />
      <GenerateInvoicePrePaid
        isOpen={showPrePaidInvoice}
        setIsOpen={setShowPrePaidInvoice}
        setShowTOS={setShowTOS}
        handleSignedTOS={handleSignedTOS}
        setTOSCustomerFee={setTOSCustomerFee}
        setTOSOptionClicked={setTOSOptionClicked}
        generatingInvoice={generatingInvoice}
      />
      <DashboardTOSModal
        isOpen={showTOS}
        setIsOpen={setShowTOS}
        onClose={handledSignedAndSetFee}
      />
    </>
  )
}